/* eslint-disable */
function set(name, value, path, age) {
  return `${name}=${value}; Max-Age=${age} ;Path=${path || "/"};`;
}

function get(ctx, name) {
  return getAll(ctx)[name];
}
function _delete(name, path) {
  return `${name}=deleted; Max-Age=0; Path=${path || "/"};`;
}
function getAll(ctx) {
  const headers = ctx?.req?.headers;
  const ck = headers.cookie || "";
  return ck
    .split(";")
    .map((str) => str.trim().split("="))
    .reduce((acc, [name, value]) => {
      return {
        ...acc,
        [name]: value,
      };
    }, {});
}

export const cookie = { set, get, getAll, delete: _delete };

export default cookie;
